module.exports = __webpack_public_path__ + "img/second.04346b06.jpg";